<script>
const affectationColor = (type) => {
  const COLORS = {
    tramo_potencial: "#0074D9",
    cursos_fluviales: "#7FDBFF",
    asentamiento: "#39CCCC",
    estrada: "#3D9970",
    ffcc: "#2ECC40",
    psrn: "#01FF70",
    gaseoducto: "#FFDC00",
    eolica: "#FF851B",
    oleoducto: "#FF4136",
    linea_electrica: "#85144b",
    lic: "#F012BE",
    zepa: "#B10DC9",
    pnatu: "#00ff85",
    embericia: "#7ce303",
    charadius: "#df8f15",
    oso: "#df4900",
    sapoconcho: "#003f0c",
    xacementos: "#3f0800",
    bic: "#00ff7f",
    camino_santiago: "#575757",
    senlleiras: "#003f25",
    xeoloxico: "#001f3f",
  }
  return COLORS[type]
}
export default {
  name: "AffectationStyleMixin",
  methods: {
    getAffectationsStyle(layer) {
      return {
        color: affectationColor(layer.name),
        weight: 4,
        opacity: 0.8,
      }
    },
  },
}
</script>
